import React from "react";
import { Link, AddToolTip } from "../../components";
import { Image } from "react-bootstrap";
import Employeepic from "../../assets/employeePhoto.jpeg";
import { MANAGE_TRANSACTION_ROUTES } from "../../utils";
const TransactionHistoryTile = (props) => {
  const { data } = props;
  return (
    <Link
      to={
        data.transactionType === "rollover"
          ? MANAGE_TRANSACTION_ROUTES.ROLLOVER_HISTORY_DETAILS
          : data.transactionType === "withdrawal"
          ? MANAGE_TRANSACTION_ROUTES.DISTRIBUTION_HISTORY_DETAILS
          : data.transactionType === "transfer"
          ? MANAGE_TRANSACTION_ROUTES.TRANSFER_HISTORY_DETAILS
          : MANAGE_TRANSACTION_ROUTES.LOAN_HISTORY_DETAILS
      }
      className="border rounded mr-3 p-3 mb-3 text-decoration-tile"
      style={{ display: "flex", marginTop: "5px", width: "100%" }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "start",
          gap: "10px",
          flexWrap: "nowrap",
          color: "black",
        }}
      >
        <div className="d-flex w-20">
          <Image
            src={Employeepic}
            alt="empic"
            roundedCircle
            className="image-transaction-history"
          />

          <div>
            {data.name.length > 30 ? (
              <AddToolTip name={data.name}>
                <div className="main-font">
                  {(data.name || "").slice(0, 30)}...
                </div>
              </AddToolTip>
            ) : (
              <div className="main-font">{data.name}</div>
            )}
            {data.ssn?.length > 30 ? (
              <AddToolTip name={data.ssn}>
                <div className="below-font">
                  {(data.ssn || "").slice(0, 30)}...
                </div>
              </AddToolTip>
            ) : (
              <div className="below-font">{data.ssn}</div>
            )}
          </div>
        </div>
        <div className="w-20">
          <div className="main-font">{data.planName}</div>
          <div className="below-font">{data.rkPlanNumber}</div>
        </div>

        <div className="w-20">
          <div className="main-font">{data.transactionType}</div>

          <div className="below-font">{data.transactionSubType}</div>
        </div>

        <div className="w-20">
          <div className="below-font">{data.amount}</div>
        </div>

        <div className="w-20">
          <div className="main-font">{data.updatedBy}</div>
          <div className="below-font">{data.updatedTime}</div>
        </div>
      </div>
    </Link>
  );
};

export default TransactionHistoryTile;
